import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from "@/components/ui/dialog";

/**
 * "New campaign" dialog — captures the Shopnomix credentials handed
 * over by the account manager. Label is user-facing, the IDs/token
 * are stored as-is and used for /v1/reporting/* calls.
 */
export default function CreateCampaignDialog({
  open, onOpenChange, form, onChange, creating, onSubmit,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid="sn-create-dialog">
        <DialogHeader>
          <DialogTitle>New Shopnomix campaign</DialogTitle>
          <DialogDescription>
            Add a Shopnomix campaign credential. Credentials come from your Shopnomix account manager.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div>
            <Label className="text-xs uppercase tracking-wider font-bold text-slate-500">Label</Label>
            <Input value={form.label} onChange={(e) => onChange({ ...form, label: e.target.value })} placeholder="e.g. RedClub Amazon US 4" />
          </div>
          <div>
            <Label className="text-xs uppercase tracking-wider font-bold text-slate-500">Campaign ID (ULID)</Label>
            <Input value={form.campaign_id} onChange={(e) => onChange({ ...form, campaign_id: e.target.value })} placeholder="01KQ8X6264DWE6J2X5CGXKYY41" className="font-mono text-xs" />
          </div>
          <div>
            <Label className="text-xs uppercase tracking-wider font-bold text-slate-500">Reporting token</Label>
            <Input value={form.reporting_token} onChange={(e) => onChange({ ...form, reporting_token: e.target.value })} placeholder="01KQ8X5BVG1D6RNPPZFHQVXK3N" className="font-mono text-xs" />
          </div>
          <div>
            <Label className="text-xs uppercase tracking-wider font-bold text-slate-500">Redirect host (optional)</Label>
            <Input value={form.redirect_host} onChange={(e) => onChange({ ...form, redirect_host: e.target.value })} placeholder="r.v2i8b.com (default)" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={() => onOpenChange(false)} disabled={creating}>Cancel</Button>
          <Button onClick={onSubmit} disabled={creating} className="bg-[#002FA7] hover:bg-[#002089] text-white" data-testid="sn-create-submit">
            {creating ? "Creating…" : "Create campaign"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
